import { configureStore } from "@reduxjs/toolkit"; 
import authReducer from "../reducers/authReducer";
import opportunitiesReducer from "../reducers/opportunitiesReducer";
import settingsReducer from "../reducers/settingsReducer";
import lookupReducer from "../reducers/lookupReducer";
import offerIssuerReducer from "../reducers/offerIssuerReducer";
import countryReducer from "../reducers/countryReducer";
import cityReducer from "../reducers/cityReducer";
import areaReducer from "../reducers/areaReducer";
import suburbReducer from "../reducers/suburbReducer";
import investorReducer from "../reducers/investorReducer";    
import bankReducer from "../reducers/bankReducer";    
import userReducer from "../reducers/userReducer";    

export const store = configureStore({
  reducer: {
   auth: authReducer,
   settings: settingsReducer,
   opportunities: opportunitiesReducer,
   lookup: lookupReducer,
   offerIssuer: offerIssuerReducer,
   country: countryReducer,
   city: cityReducer,
   area: areaReducer,
   suburb: suburbReducer,
   investor: investorReducer, 
   bank: bankReducer, 
   user: userReducer, 
  },
  devTools: true,
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
